var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":"is-danger","title":"Delete Record"},nativeOn:{"click":function($event){return _vm.triggerPopup.apply(null, arguments)}}},[_c('b-icon',{attrs:{"icon":"trash"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }